const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const SLOT_COLUMN_COUNT = 7;

const timeSlotToMinutes = (timeString = '') => {
  if (!timeString || timeString === '---') return 0;
  const [hours, minutes] = timeString.split(':').map(Number);
  return (hours || 0) * 60 + (minutes || 0);
};

export const sortSlotsByTime = (slots = []) =>
  [...slots].sort((a, b) => timeSlotToMinutes(a.startTime) - timeSlotToMinutes(b.startTime));

export const getDayListForTimeSlot = () => {
  const result = [];
  const today = new Date();

  for (let i = 0; i < 7; i += 1) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    const dayName = WEEKDAYS[date.getDay()];
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    result.push({
      day: dayName,
      rowId: dayName.toLowerCase(),
      short: `${day}/${month}/${year}`,
      isToday: i === 0,
    });
  }

  return result;
};

export const normalizeSlot = (slot = {}) => ({
  _id: slot._id,
  name: slot.name || '',
  startTime: slot.startTime || '',
  enabled: Boolean(slot.enabled),
});

export const padSlotList = (list = [], size = SLOT_COLUMN_COUNT) => {
  const normalized = sortSlotsByTime(list.map(normalizeSlot)).map((slot) => ({ ...slot }));
  while (normalized.length < size) {
    normalized.push({ name: '', startTime: '', enabled: false });
  }
  return normalized.slice(0, size);
};

export const getColumnCount = (defaultTimeSlots = [], timeSlotsList = []) => {
  const dayLists = (timeSlotsList || []).map((entry) => entry.list || []);
  const maxDayLength = dayLists.reduce((max, list) => Math.max(max, list.length), 0);
  return Math.max(SLOT_COLUMN_COUNT, defaultTimeSlots.length, maxDayLength);
};

export const buildTimeSlotGrid = (defaultTimeSlots = [], timeSlotsList = []) => {
  const columnCount = getColumnCount(defaultTimeSlots, timeSlotsList);
  const daySlotMap = {};

  (timeSlotsList || []).forEach((entry) => {
    if (entry?.date) {
      daySlotMap[String(entry.date).toLowerCase()] = entry.list || [];
    }
  });

  const rows = [
    {
      rowId: 'defaultSlot',
      label: 'Default',
      subLabel: '',
      isToday: false,
      slots: padSlotList(defaultTimeSlots, columnCount),
    },
    ...getDayListForTimeSlot().map((day) => ({
      rowId: day.rowId,
      label: day.day,
      subLabel: day.isToday ? 'Today' : day.short,
      isToday: day.isToday,
      slots: padSlotList(daySlotMap[day.rowId] || [], columnCount),
    })),
  ];

  return { rows, columnCount };
};

export const buildTimeSlotSavePayload = (rows = []) => {
  const todayRowId = getDayListForTimeSlot()[0]?.rowId;
  const newList = rows.map((row) => ({
    date: row.rowId,
    list: row.slots.map((slot) => ({
      name: slot.name || '',
      startTime: slot.startTime || '',
      enabled: Boolean(slot.enabled),
    })),
  }));

  const todayRow = rows.find((row) => row.rowId === todayRowId);
  const list = (todayRow?.slots || [])
    .filter((slot) => slot.name && slot.startTime)
    .map((slot) => ({
      name: slot.name,
      startTime: slot.startTime,
      enabled: Boolean(slot.enabled),
      isEnabled: Boolean(slot.enabled),
    }));

  return { list, newList };
};

export const isSlotConfigured = (slot) => Boolean(slot?.name && slot?.startTime);

export const serializeTimeSlotGrid = (rows = []) =>
  JSON.stringify(
    rows.map((row) => ({
      rowId: row.rowId,
      slots: row.slots.map((slot) => ({
        name: slot.name || '',
        startTime: slot.startTime || '',
        enabled: Boolean(slot.enabled),
      })),
    }))
  );
